import { Link } from "react-router-dom";
import LegalHeader from "@/components/landing/LegalHeader";
import Footer from "@/components/landing/Footer";

export default function CookiePolicy() {
  return (
    <main data-testid="cookie-page" className="bg-white text-[#0A0A0A]">
      <LegalHeader />

      <section className="max-w-[820px] mx-auto px-6 md:px-8 py-16 md:py-24">
        <span className="inline-block text-xs uppercase tracking-[0.2em] font-semibold text-[#B40101] mb-4">
          Documento legale
        </span>
        <h1 className="font-display font-bold text-[#0A0A0A] text-4xl md:text-5xl tracking-tight leading-tight">
          Cookie Policy
        </h1>
        <p className="mt-4 text-[#0A0A0A]/60 text-sm">
          Ultimo aggiornamento: 11 dicembre 2026
        </p>

        <div className="mt-10 space-y-8 text-[#0A0A0A]/85 text-[16px] md:text-[17px] leading-relaxed">

          {/* 1. Cosa sono */}
          <section data-testid="cookie-section-cosa-sono">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-2 mb-4">
              1. Cosa sono i cookie
            </h2>
            <p>
              I cookie sono piccoli file di testo che i siti visitati inviano al browser dell&apos;utente, dove vengono memorizzati per essere ritrasmessi al sito alla successiva visita. Sono utilizzati per garantire il funzionamento del sito, migliorarne le prestazioni e, in alcuni casi, raccogliere informazioni sui comportamenti di navigazione.
            </p>
          </section>

          {/* 2. Cookie utilizzati */}
          <section data-testid="cookie-section-utilizzati">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              2. Cookie utilizzati su questo sito
            </h2>
            <p>
              ValutaGenio utilizza <strong>esclusivamente cookie tecnici essenziali</strong> al funzionamento del sito. <strong>Non sono presenti cookie di profilazione, marketing o pubblicità comportamentale</strong>, né di terze parti finalizzati al tracciamento dell&apos;utente.
            </p>

            <div className="mt-6 overflow-x-auto">
              <table className="w-full text-left border-collapse bg-white rounded-xl overflow-hidden vg-card-shadow">
                <thead>
                  <tr className="bg-[#404040] text-white">
                    <th className="px-4 py-3 text-[14px] font-semibold">Nome</th>
                    <th className="px-4 py-3 text-[14px] font-semibold">Tipologia</th>
                    <th className="px-4 py-3 text-[14px] font-semibold">Finalità</th>
                    <th className="px-4 py-3 text-[14px] font-semibold">Durata</th>
                  </tr>
                </thead>
                <tbody className="text-[14px]">
                  <tr className="border-b border-[#E5E5E5]">
                    <td className="px-4 py-3 font-mono text-[13px]">vg_cookie_consent</td>
                    <td className="px-4 py-3">Tecnico</td>
                    <td className="px-4 py-3">Memorizza la scelta dell&apos;utente sul banner cookie</td>
                    <td className="px-4 py-3">12 mesi</td>
                  </tr>
                  <tr className="border-b border-[#E5E5E5]">
                    <td className="px-4 py-3 font-mono text-[13px]">session_id</td>
                    <td className="px-4 py-3">Tecnico di sessione</td>
                    <td className="px-4 py-3">Gestione della sessione utente durante la navigazione</td>
                    <td className="px-4 py-3">Sessione</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="mt-5">
              I cookie tecnici essenziali <strong>non richiedono il consenso</strong> dell&apos;utente ai sensi dell&apos;art. 122 del Codice Privacy italiano e delle Linee Guida del Garante del 10 giugno 2021.
            </p>
          </section>

          {/* 3. Cookie analytics */}
          <section data-testid="cookie-section-analytics">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              3. Strumenti di analisi
            </h2>
            <p>
              Il sito utilizza <strong>PostHog</strong>, uno strumento di analytics configurato in modalità privacy-friendly, con:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>anonimizzazione dell&apos;indirizzo IP;</li>
              <li>nessun tracciamento cross-site;</li>
              <li>nessuna creazione di profilo identificabile dell&apos;utente;</li>
              <li>dati aggregati a fini statistici.</li>
            </ul>
            <p className="mt-3">
              Tale strumento è assimilabile, per finalità e modalità d&apos;uso, a un cookie tecnico ai sensi delle Linee Guida del Garante.
            </p>
          </section>

          {/* 4. Gestione */}
          <section data-testid="cookie-section-gestione">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              4. Come gestire i cookie
            </h2>
            <p>
              L&apos;utente può in qualsiasi momento gestire o disabilitare i cookie attraverso le impostazioni del proprio browser. Di seguito le guide ufficiali:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>
                <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#B40101] font-semibold hover:underline">
                  Google Chrome
                </a>
              </li>
              <li>
                <a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer" className="text-[#B40101] font-semibold hover:underline">
                  Mozilla Firefox
                </a>
              </li>
              <li>
                <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#B40101] font-semibold hover:underline">
                  Apple Safari
                </a>
              </li>
              <li>
                <a href="https://support.microsoft.com/it-it/windows/eliminare-e-gestire-i-cookie-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer" className="text-[#B40101] font-semibold hover:underline">
                  Microsoft Edge
                </a>
              </li>
            </ul>
            <p className="mt-4">
              La disabilitazione dei cookie tecnici essenziali potrebbe compromettere il corretto funzionamento del sito.
            </p>
          </section>

          {/* 5. Reset consenso */}
          <section data-testid="cookie-section-reset">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              5. Revoca del consenso
            </h2>
            <p>
              Puoi modificare in qualsiasi momento le tue preferenze cliccando sul pulsante qui sotto. Riaprirà il banner cookie.
            </p>
            <button
              data-testid="cookie-reset-button"
              onClick={() => {
                try {
                  localStorage.removeItem("vg_cookie_consent");
                  window.location.reload();
                } catch (e) {
                  window.location.reload();
                }
              }}
              className="mt-5 inline-flex items-center gap-2 bg-[#404040] hover:bg-[#2A2A2A] text-white font-semibold px-5 py-3 rounded-xl transition-all duration-200 hover:-translate-y-0.5"
            >
              Reimposta preferenze cookie
            </button>
          </section>

          {/* 6. Titolare */}
          <section data-testid="cookie-section-titolare">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              6. Titolare del trattamento
            </h2>
            <div className="mt-2 bg-[#F5F5F5] rounded-xl p-5 md:p-6 border border-[#E5E5E5]">
              <p className="mb-1"><strong>Paul Fasciano</strong></p>
              <p className="mb-1">P.IVA: <strong>12849491001</strong></p>
              <p className="mb-1">Sede: Roma, Italia</p>
              <p>
                Email:{" "}
                <a href="mailto:info@valutagenio.com" className="text-[#B40101] font-semibold hover:underline">
                  info@valutagenio.com
                </a>
              </p>
            </div>
            <p className="mt-5">
              Per maggiori dettagli sul trattamento dei dati personali consulta la nostra{" "}
              <Link to="/privacy" className="text-[#B40101] font-semibold hover:underline">
                Privacy Policy
              </Link>
              .
            </p>
          </section>
        </div>
      </section>

      <Footer />
    </main>
  );
}
